import { makeVar } from "@apollo/client";
export const selectedGroupVar = makeVar({});
export const individualScheduleVar = makeVar([]);
export const trialLessonVar = makeVar([]);
export const selectedSubscriptionVar = makeVar(undefined);
export const selectedEventVar = makeVar(undefined);
export const selectedConcertVar = makeVar(undefined);
